///<amd-module name = "Core/Medius.Core.Web/Scripts/Medius/core/store/inbox/documentVisibility"/>
import { createLocalStore } from "Core/Medius.Core.Web/Scripts/Medius/lib/store/async";

const prefix = "Core:document-type-visibility";

export const documentVisibilityStore = createLocalStore(prefix);